import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Intro from "./Intro";




ReactDOM.render(
   <Intro/>
,document.getElementById("root")
);